// @core/api/endpoints/task/update_view.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateViewRequest,
  ViewResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update view
 * Updates a saved task view. Only the view owner may update it. Only provided fields are updated.
 */
export async function UpdateView(
  view_id: string,
  data: UpdateViewRequest,
  options?: RequestOptions
): Promise<ViewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-views/:view_id`;
  requestPath = requestPath.replace(':view_id', encodeURIComponent(view_id));
  const requestOptions = options;
  return client.put<ViewResponse>(requestPath, data, requestOptions);
}
